import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { api } from '../services';
import { useAuth } from './auth';

function WithAxios ({ children }) {
  const { logout } = useAuth();
  const history = useHistory();

  useMemo(() => {
    api.interceptors.response.use(response => response, async (error) => {
      if(error.response?.data.auth === false) {
        logout();
        history.push('/');
      }
      return Promise.reject(error);
    })
  }, [logout, history]);
  return children;
}

export default WithAxios;